import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LinkColor } from '@freelancer/ui/link';
import { Margin } from '@freelancer/ui/margin';

interface NavigationMenuListItem {
  linkDescription: string;
  linkUrl: string;
}

@Component({
  standalone: false,
  selector: 'app-navigation-menu-list',
  template: `
    <div class="LinksColumn">
      @for (item of list; track trackByLinkUrl($index, item)) {
        <fl-link
          flTrackingLabel="SkillLink"
          [class]="getTabletMarginClass()"
          [link]="item.linkUrl"
          [color]="listColor"
          [newTab]="false"
        >
          {{ item.linkDescription }}
        </fl-link>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navigation-menu-list.component.scss'],
})
export class NavigationMenuListComponent {
  @Input() listColor = LinkColor.LIGHT;
  @Input() marginBottomTablet?: Margin;
  @Input() list: readonly NavigationMenuListItem[] = [];

  getTabletMarginClass(): string {
    const baseClass = 'mb-small';
    if (!this.marginBottomTablet) return baseClass;
    return `${baseClass} tablet:mb-${this.marginBottomTablet}`;
  }

  trackByLinkUrl(_: number, item: NavigationMenuListItem): string {
    return item.linkUrl;
  }
}
